module.exports = __webpack_public_path__ + "static/media/service_happy-hour-back.9ea0eff2.jpg";